import { render, staticRenderFns } from "./CreateFeedContainerCaption.vue?vue&type=template&id=0f0219ac&"
import script from "./CreateFeedContainerCaption.vue?vue&type=script&lang=ts&"
export * from "./CreateFeedContainerCaption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports